import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d8b97728")

_pushScopeId("data-v-d8b97728")
const _hoisted_1 = { class: "pt-16 fixed inset-0 overflow-y-auto z-10 overflow-scroll" }
const _hoisted_2 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "absolute inset-0 backdrop-filter backdrop-blur-xl" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", {
  "aria-hidden": "true",
  class: "hidden sm:inline-block sm:align-middle sm:h-screen"
}, "​", -1)
const _hoisted_5 = {
  class: "z-0 inline-block align-bottom text-left transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full",
  style: {"width":"-moz-available"}
}
const _hoisted_6 = { class: "float-right  -mr-7 mt-5" }
const _hoisted_7 = { class: "text-3xl bold text-bp-dark bg-gray-70 text-center\n      p-5 pt-2 pb-0 pb-4" }
const _hoisted_8 = { class: "grid md:grid-cols-2 lg:grid-cols-3 gap-4" }
const _hoisted_9 = { class: "row-span-3 dark:bg-gray-700 bg-gray-200 rounded-3xl p-2" }
const _hoisted_10 = { class: "z-0 text-xl bold dark:text-gray-400 text-bp-dark pb-0 p-2" }
const _hoisted_11 = { class: "z-0 text-xs bold dark:text-gray-400 text-bp-dark pt-0 p-2" }
const _hoisted_12 = { class: "row-span-3 dark:bg-gray-700 bg-gray-200 rounded-3xl p-2" }
const _hoisted_13 = { class: "z-0 text-xl bold dark:text-gray-400 text-bp-dark pb-0 p-2" }
const _hoisted_14 = { class: "z-0 text-xs bold dark:text-gray-400 text-bp-dark pt-0 p-2" }
const _hoisted_15 = { class: " bg-gray-200 dark:bg-gray-700 rounded-3xl p-2" }
const _hoisted_16 = { class: "z-0 text-xl dark:text-gray-400 bold text-bp-dark pb-0 p-2 pt-0" }
const _hoisted_17 = { class: "z-0 text-xs dark:text-gray-400 bold text-bp-dark pt-0 p-2" }
const _hoisted_18 = { class: "bg-gray-200 dark:bg-gray-700 rounded-3xl p-2" }
const _hoisted_19 = { class: "z-0 text-xl bold dark:text-gray-400 text-bp-dark pb-0 p-2 pt-0" }
const _hoisted_20 = { class: "z-0 text-xs bold dark:text-gray-400 text-bp-dark pt-0 p-2" }
const _hoisted_21 = { class: "grid sm:grid-cols-2 gap-4 mx-auto max-w-sm sm:max-w-full" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "grid grid-cols-3 mb-2" }, [
  /*#__PURE__*/_createVNode("div", { class: " w-7 h-7 rounded-full text-bp-dark text-center p-0.5 bg-gray-200 dark:bg-gray-500" }, " 1 "),
  /*#__PURE__*/_createVNode("div", { class: "grid grid-cols-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "justify-self-center pl-1.5 pt-1 w-7 h-7 rounded-full text-bp-dark text-center p-0.5 bg-gray-200 dark:bg-gray-500" }, [
      /*#__PURE__*/_createVNode("svg", {
        height: "17",
        viewBox: "0 0 65.603 43.6",
        width: "17",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        /*#__PURE__*/_createVNode("path", {
          id: "Path_236",
          d: "M59.1,0H5.5A5.549,5.549,0,0,0,0,5.5V37.1a5.549,5.549,0,0,0,5.5,5.5H59.1a5.549,5.549,0,0,0,5.5-5.5V5.5A5.421,5.421,0,0,0,59.1,0ZM7.9,8h8a3.222,3.222,0,0,1,3.2,3.2,3.159,3.159,0,0,1-3.2,3.2h-8a3.222,3.222,0,0,1-3.2-3.2A3.159,3.159,0,0,1,7.9,8ZM60,30.3H4.7v-9H60Z",
          "data-name": "Path 236",
          stroke: "#707070",
          "stroke-width": "1",
          transform: "translate(0.5 0.5)"
        })
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "justify-self-center pl-1.5 pt-1  w-7 h-7 rounded-full text-bp-dark text-center p-0.5 bg-gray-200 dark:bg-gray-500" }, [
      /*#__PURE__*/_createVNode("svg", {
        height: "17",
        viewBox: "0 0 65.603 43.6",
        width: "17",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        /*#__PURE__*/_createVNode("path", {
          id: "Path_236",
          d: "M59.1,0H5.5A5.549,5.549,0,0,0,0,5.5V37.1a5.549,5.549,0,0,0,5.5,5.5H59.1a5.549,5.549,0,0,0,5.5-5.5V5.5A5.421,5.421,0,0,0,59.1,0ZM7.9,8h8a3.222,3.222,0,0,1,3.2,3.2,3.159,3.159,0,0,1-3.2,3.2h-8a3.222,3.222,0,0,1-3.2-3.2A3.159,3.159,0,0,1,7.9,8ZM60,30.3H4.7v-9H60Z",
          "data-name": "Path 236",
          stroke: "#707070",
          "stroke-width": "1",
          transform: "translate(0.5 0.5)"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("div", {
    class: "justify-self-right w-7 h-7 rounded-full text-bp-dark text-center p-0.5 bg-gray-200 dark:bg-gray-500",
    style: {"justify-self":"right"}
  }, " x ")
], -1)
const _hoisted_23 = { class: "bg-gray-100  dark:bg-gray-600 rounded-3xl -mx-4 -mb-6 p-4" }
const _hoisted_24 = { class: "rounded-3xl  dark:text-gray-400 text-bp-dark text-center border-1px-dove-gray-2 p-2 py-16 mb-1" }
const _hoisted_25 = { class: "z-0 text-xl pb-0 p-2 pt-0" }
const _hoisted_26 = { class: "z-0 text-xs pt-0 p-2" }
const _hoisted_27 = { class: "rounded-3xl dark:text-gray-400 text-bp-dark text-center border-1px-dove-gray-2 p-2 py-0.5 mb-1" }
const _hoisted_28 = { class: "z-0 text-xl pb-0 p-2 pt-0" }
const _hoisted_29 = { class: "rounded-3xl dark:text-gray-400 text-bp-dark text-center border-1px-dove-gray-2 p-2 py-0.5 mb-1" }
const _hoisted_30 = { class: "z-0 text-xs pb-0 p-2 pt-0" }
const _hoisted_31 = { class: "rounded-3xl dark:text-gray-400 text-bp-dark text-center border-1px-dove-gray-2 p-2 py-3 mt-4 mb-1" }
const _hoisted_32 = { class: "z-0 text-xl pb-0 p-2 pt-0" }
const _hoisted_33 = { class: "py-7 sm:py-20 px-5" }
const _hoisted_34 = { class: "text-sm text-center dark:text-gray-400 text-bp-dark" }
const _hoisted_35 = { class: "text-6xl text-center dark:text-gray-400 font-bold text-bp-dark p-2" }
const _hoisted_36 = { class: "text-md text-center dark:text-gray-400 font-bold text-bp-dark" }
const _hoisted_37 = { class: "text-sm text-center dark:text-gray-400 text-bp-dark" }
const _hoisted_38 = { class: "grid sm:grid-cols-2 gap-4 sm:gap-0 sm:mx-7" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_btn_edit = _resolveComponent("btn-edit")
  const _component_btn_close = _resolveComponent("btn-close")
  const _component_text_upload_edit_dialog = _resolveComponent("text-upload-edit-dialog")
  const _component_image_upload_dialog = _resolveComponent("image-upload-dialog")
  const _component_default_card_layout = _resolveComponent("default-card-layout")
  const _component_DefaultButton = _resolveComponent("DefaultButton")
  const _component_router_link = _resolveComponent("router-link")
  const _component_default_button = _resolveComponent("default-button")
  const _component_DefaultCardLayout = _resolveComponent("DefaultCardLayout")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.showButton === true)
      ? (_openBlock(), _createBlock(_component_btn_edit, {
          key: 0,
          "btn-position": "mr-6 -mt-1",
          "button-text": "Search free Images",
          "button-x-padding": "px-1",
          "button-y-padding": "py-2",
          class: "text-xs mb-1",
          onClick: _ctx.toggleDialog
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", {
          "aria-hidden": "true",
          class: "fixed inset-0 transition-opacity",
          title: "overlay_for_confirm",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelDialog && _ctx.cancelDialog(...args)))
        }, [
          _hoisted_3
        ]),
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_btn_close, {
              "css-class": "absolute z-20",
              onClick: _ctx.cancelDialog
            }, null, 8, ["onClick"])
          ]),
          _createVNode(_component_DefaultCardLayout, { "card-padding": "px-6 md:px-6 mb-6" }, {
            default: _withId(() => [
              _createVNode("h1", _hoisted_7, _toDisplayString(_ctx.$t("profile.subscribed.changeTitle")), 1),
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("h1", _hoisted_10, _toDisplayString(_ctx.$t("profile.createBoostpack1.createTextTitle")), 1),
                  _createVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("profile.createBoostpack1.createTextDetail")), 1),
                  _renderSlot(_ctx.$slots, "TextEditButton", {}, () => [
                    _createVNode(_component_text_upload_edit_dialog, { class: "absolute" })
                  ])
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("h1", _hoisted_13, _toDisplayString(_ctx.$t("profile.createBoostpack1.createPicturesTitle")), 1),
                  _createVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("profile.createBoostpack1.createPicturesDetail")), 1),
                  _renderSlot(_ctx.$slots, "PictureUploadButton", {}, () => [
                    _createVNode(_component_image_upload_dialog, { class: "absolute" })
                  ])
                ]),
                _createVNode("div", _hoisted_15, [
                  _createVNode("h1", _hoisted_16, _toDisplayString(_ctx.$t("profile.createBoostpack1.createLogoTitle")), 1),
                  _createVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("profile.createBoostpack1.createLogoDetail")), 1)
                ]),
                _createVNode("div", _hoisted_18, [
                  _createVNode("h1", _hoisted_19, _toDisplayString(_ctx.$t("profile.createBoostpack1.createLinkTitle")), 1),
                  _createVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("profile.createBoostpack1.createLinkDetail")), 1)
                ])
              ]),
              _createVNode("div", _hoisted_21, [
                _createVNode("div", null, [
                  _createVNode(_component_default_card_layout, {
                    "card-bg": "bg-white dark:bg-gray-700",
                    "card-padding": "px-4",
                    class: "flex-shrink-0 z-0 sm:max-w-sm max-w-s"
                  }, {
                    default: _withId(() => [
                      _hoisted_22,
                      _createVNode("div", _hoisted_23, [
                        _createVNode("div", _hoisted_24, [
                          _createVNode("h1", _hoisted_25, _toDisplayString(_ctx.$t("profile.createBoostpack1.createInputText")), 1),
                          _createVNode("p", _hoisted_26, _toDisplayString(_ctx.$t("profile.createBoostpack1.createInputTextDetail")), 1)
                        ]),
                        _createVNode("div", _hoisted_27, [
                          _createVNode("h1", _hoisted_28, _toDisplayString(_ctx.$t("profile.createBoostpack1.createInputTextName")), 1)
                        ]),
                        _createVNode("div", _hoisted_29, [
                          _createVNode("h1", _hoisted_30, _toDisplayString(_ctx.$t("profile.createBoostpack1.createInputTextAbout")), 1)
                        ]),
                        _createVNode("div", _hoisted_31, [
                          _createVNode("h1", _hoisted_32, _toDisplayString(_ctx.$t("profile.createBoostpack1.createInputTextLogo")), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_default_card_layout, {
                  "card-bg": "bg-white dark:bg-gray-700",
                  class: "flex-shrink-0 z-0 sm:max-w-sm max-w-s"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_33, [
                      _createVNode("p", _hoisted_34, _toDisplayString(_ctx.$t("profile.createBoostpack1.createStyleDetail")), 1),
                      _createVNode("p", _hoisted_35, _toDisplayString(_ctx.$t("profile.createBoostpack1.createStyleAddItem")), 1),
                      _createVNode("p", _hoisted_36, _toDisplayString(_ctx.$t("profile.createBoostpack1.createStyleAddItemText")), 1),
                      _createVNode("p", _hoisted_37, _toDisplayString(_ctx.$t("profile.createBoostpack1.createStyleAddItemDetail")), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createVNode("div", _hoisted_38, [
                _createVNode(_component_router_link, { to: "/profile/shared" }, {
                  default: _withId(() => [
                    _createVNode(_component_DefaultButton, {
                      "button-text": _ctx.$t('profile.createBoostpack1.btnDelete'),
                      "button-color": "bg-gray-300",
                      "button-width": "w-auto",
                      "button-x-padding": "px-7",
                      class: "order-last sm:order-first"
                    }, null, 8, ["button-text"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, { to: "/profile/shared/publish" }, {
                  default: _withId(() => [
                    _createVNode(_component_default_button, {
                      "button-text": "update",
                      "button-width": "w-auto",
                      "button-x-padding": "px-7"
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 3
          })
        ])
      ])
    ], 512), [
      [_vShow, _ctx.dialogVisible]
    ])
  ], 64))
})